import CancelableApi from "./CancelableApi";
import { ActionEvent } from "../component/SSEButton";
import CancelableAxiosInstance from "./CancelableAxiosInstance";
import { StudyQuery } from "./StudyApi";

export default class StudyActionApi extends CancelableApi {
  static with(axios: CancelableAxiosInstance) {
    return new StudyActionApi(axios);
  }

  processStudyRule(query: any = {}): Promise<ActionEvent> {
    return this.client.post("/study-actions/process-rules", query).then((response) => response.data);
  }

  processStudyInference(query: StudyQuery): Promise<ActionEvent> {
    return this.client.post("/study-actions/process-inferences", query).then((response) => response.data);
  }
}
